import {
    Alert, Box, Button, CircularProgress, Container, Drawer,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid, InputLabel, MenuItem,
    Radio,
    RadioGroup,
    Select, Stack, TextField, Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';
import { InputPhoneMask } from '../../components/input-numbers';
import { useGetUsersQuery } from '../../store/userApi';
import { ImgStyled } from '../../utils/shop';

const Staff = (props) => {
  const { show, setShow, setReload } = props
  const [loading, setLoading] = useState(false)
  const { refetch } = useGetUsersQuery();
  const [imgSrc, setImgSrc] = useState('/images/avatars/1.png')
  const defaultValues = {
    username: '',
    password: '',
    email: '',
    emailpass: '',
    name: '',
    phone: '',
    role: 'ROLE_ADMIN'
  }
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    getValues
  } = useForm({ defaultValues })

  useEffect(() => {
    !show && reset(defaultValues);
  }, [show])

  const onSubmit = async (data, e) => {
    e.preventDefault();

    const params = {
        "username": data.username,
        "password": data.password,
        "email": data.email,
        "emailpass": data.emailpass,
        "name": data.name,
        "phone": data.phone,
        "role": data.role,
        "task_code": data.task_code,
        "task_charge": data.task_charge,
        "task_section": data.task_section
    };

    await apiService.post('/staff', params)
    .then(response => {
        toast.success('등록 되었습니다.')
        refetch();

        setReload(reload => reload + 1)
    }).catch(error => {
        toast.error('등록이 실패했습니다.')
        console.error(error)
    })

    setShow(false)
  }

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
    }
    setShow(open);
  };

  return (
    <Drawer anchor='right' open={show} onClose={toggleDrawer(false)}>
        <Container sx={{width: '800px', pt: 8, px: '2rem !important'}}>
            <form onSubmit={handleSubmit(onSubmit)} id="memberform">
                <Box sx={{ mb: 9, textAlign: 'center' }}>
                <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                    Staff 등록
                </Typography>
                </Box>

                <Grid container spacing={6}>

                    <Grid item xs={12} sx={{ my: 5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <ImgStyled src={imgSrc} alt='Profile Pic' />
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Stack direction="row" alignItems="center" spacing={{ xs: 1, sm: 4 }} >
                            <FormControl fullWidth>
                                <Controller
                                    name='username'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=''
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='사용자ID'
                                            id='username'
                                            onChange={onChange}
                                            placeholder='사용자ID를 입력해주세요'
                                            error={Boolean(errors.username)}
                                            helpertext={errors?.message}
                                            aria-describedby='validation-async-username'
                                            variant="standard"
                                        />
                                    )}
                                />
                            </FormControl>
                        </Stack>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <Controller
                                name='password'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=''
                                render={({ field: { value, onChange } }) => (
                                    <TextField
                                        type="password"
                                        value={value}
                                        label='비밀번호'
                                        id='password'
                                        onChange={onChange}
                                        placeholder='비밀번호를 입력해주세요'
                                        error={Boolean(errors.password)}
                                        helpertext={errors?.message}
                                        aria-describedby='validation-async-password'
                                        variant="standard"
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <Controller
                                name='name'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=''
                                render={({ field: { value, onChange } }) => (
                                    <TextField
                                        value={value}
                                        label='이름'
                                        id='name'
                                        onChange={onChange}
                                        placeholder='이름을 입력해주세요'
                                        error={Boolean(errors.name)}
                                        helpertext={errors?.message}
                                        aria-describedby='validation-async-name'
                                        variant="standard"
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="phone">전화번호</InputLabel>
                            <Controller
                                name='phone'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=''
                                render={({ field: { value, onChange } }) => (
                                    <InputPhoneMask                                    
                                        mask="000-0000-0000"
                                        value={value}
                                        label='전화번호'
                                        id='phone'
                                        onChange={onChange}
                                        placeholder='010-1234-5678'
                                        error={Boolean(errors.phone)}
                                        helpertext={errors?.message}                                    
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <Controller
                                name='email'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=''
                                render={({ field: { value, onChange } }) => (
                                    <TextField
                                        type='email'
                                        value={value}
                                        label='Email'
                                        id='email'
                                        onChange={onChange}
                                        placeholder='사용자 이메일주소를 입력해주세요'
                                        error={Boolean(errors.email)}
                                        helpertext={errors?.message}
                                        aria-describedby='validation-async-email'
                                        variant="standard"
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <Controller
                                name='emailpass'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=''
                                render={({ field: { value, onChange } }) => (
                                    <TextField
                                        type="password"
                                        value={value}
                                        label='이메일 비밀번호'
                                        id='emailpass'
                                        onChange={onChange}
                                        placeholder='비밀번호를 입력해주세요'
                                        error={Boolean(errors.emailpass)}
                                        helpertext={errors?.message}
                                        aria-describedby='validation-async-emailpass'
                                        variant="standard"
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel id='role'>Role</InputLabel>
                            <Controller
                                name='role'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=''
                                render={({ field: { value, onChange } }) => (
                                    <Select
                                        label='Role'
                                        value={value}
                                        onChange={onChange}
                                        labelId='role'
                                        error={Boolean(errors.role)}
                                        helpertext={errors?.message}
                                        variant="standard"
                                    >
                                        <MenuItem value='ROLE_ADMIN'>관리자</MenuItem>
                                        <MenuItem value='ROLE_MANAGER'>매니저</MenuItem>
                                    </Select>
                                )}
                            />
                        </FormControl>
                    </Grid>                    
                </Grid>

                <Grid container spacing={6} sx={{ mt: 5 }}>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <Controller
                                name='task_code'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=''
                                render={({ field: { value, onChange } }) => (
                                    <TextField
                                        value={value}
                                        label='담당업무코드'
                                        id='task_code'
                                        onChange={onChange}
                                        placeholder='업무코드를 입력해주세요'
                                        error={Boolean(errors.task_code)}
                                        helpertext={errors?.message}
                                        variant="standard"
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel id='role'>담당업무</InputLabel>
                            <Controller
                                name='task_charge'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=''
                                render={({ field: { value, onChange } }) => (
                                    <Select
                                        label='task_charge'
                                        value={value}
                                        onChange={onChange}
                                        labelId='task_charge'
                                        error={Boolean(errors.task_charge)}
                                        helpertext={errors?.message}
                                        variant="standard"
                                    >
                                        <MenuItem value='영업'>영업</MenuItem>
                                        <MenuItem value='구매'>구매</MenuItem>
                                        <MenuItem value='마케팅'>마케팅</MenuItem>
                                    </Select>
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>                            
                        <FormControl component="fieldset" fullWidth>
                            <FormLabel component="legend">업체분류</FormLabel>
                            <Controller
                                name="task_section"
                                control={control}
                                defaultValue="국가연구소"
                                render={({ field }) => (
                                    <RadioGroup row {...field}>
                                        <FormControlLabel value="국가연구소" control={<Radio />} label="국가연구소" />
                                        <FormControlLabel value="제조업" control={<Radio />} label="제조업" />
                                        <FormControlLabel value="학교" control={<Radio />} label="학교" />
                                        <FormControlLabel value="도소매" control={<Radio />} label="도소매" />
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <Alert severity='warning'>
                            사이트 관리의 메일서버와 동일한 메일 호스트 주소를 사용해야 합니다.
                        </Alert>
                    </Grid>
                </Grid>
            </form>

            <Stack direction="row" spacing={2} sx={{ py: 16, justifyContent: 'center' }}>
                <Button type="submit" form="memberform" variant='contained'>
                    {loading ? (
                    <CircularProgress
                        sx={{
                        color: 'common.white',
                        width: '20px !important',
                        height: '20px !important',
                        mr: theme => theme.spacing(2)
                        }}
                    />
                    ) : null}
                    등록
                </Button>
                <Button variant='outlined' color='secondary' onClick={() => setShow(false)}>
                    취소
                </Button>
            </Stack>
        </Container>
    </Drawer>
  )
}

export default Staff
